// extracted by mini-css-extract-plugin
module.exports = {"container":"menu-module--container--1r876","list":"menu-module--list--2x1Zg"};